export default __webpack_public_path__ + "static/media/main-img.a7a83fa7.png";